import React, { useState, useEffect } from 'react'
import Layout from '../../components/Layout'
import axios from 'axios'
import { useParams, useNavigate } from 'react-router-dom'
import styles from './BootcampDetail.module.css'
import {
  InfoProgram,
  SilabusMateri,
  FasilitasPelatihan,
  KenapaHarusBootcamp,
} from './components'
import BelajarMandiri from '../../components/BelajarMandiri'

import { Spin } from 'antd'
// import { Link } from 'react-router-dom'
// import { ReactComponent as IcArrowRight } from '../../assets/icon/ic-arrow-right.svg'

import './BootcampDetail.scss'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'
import ProgramTerdekat from './components/ProgramTerdekat'

const BootcampDetail = () => {
  const currentUser = useSelector(selectCurrentUser)
  const [dataUser, setDataUser] = useState(null)
  const [programTerdekatData, setProgramTerdekatData] = useState(null)
  const [program, setProgram] = useState(null)
  let { slug } = useParams()
  let navigate = useNavigate()

  useEffect(() => {
    axios
      .get(`/detail-product/${slug}`)
      .then((res) => {
        setProgram(res.data)
      })
      .catch((err) => {
        navigate(`/not-found`)
      })
    if (currentUser) {
      axios({
        method: 'get',
        url: '/profile',
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      }).then(({ data }) => {
        setDataUser(data)
      })
    }
    axios.get('/show-index').then((res) => {
      const data = res.data
      setProgramTerdekatData(data.program_terdekat)
    })
  }, [slug, navigate, currentUser])

  return (
    <Layout idPage="program-detail-page">
      {program === null ? (
        <div className="loadingContainer">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="container">
            <InfoProgram program={program} dataUser={dataUser} />
            <div className={`${styles.silabusFasilitasGroup}`}>
              <div className={styles.detailProgramCard}>
                <div className={styles.detailProgramCardInner}>
                  <SilabusMateri program={program} />
                </div>
              </div>
              <div className={styles.detailProgramCard}>
                <div className={styles.detailProgramCardInner}>
                  <FasilitasPelatihan program={program} />
                </div>
              </div>
            </div>
          </div>
          <KenapaHarusBootcamp />
          <ProgramTerdekat
            dataUser={dataUser}
            programTerdekatData={programTerdekatData}
          />
          <BelajarMandiri />
        </>
      )}
    </Layout>
  )
}

export default BootcampDetail
